/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import 'cross-fetch/polyfill';
import { WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD, WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD_FAIL, WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD_RECEIVE, WPF_CUSTOM_THEME_V2_REQUEST, WPF_CUSTOM_THEME_V2_REQUEST_FAIL, WPF_CUSTOM_THEME_V2_RESPONSE_RECEIVE } from '@engine/actions/action-types';
/**
 * Action Creators for WPF Custom Theme
 */

export var wpfCustomThemeV2ResponseReceive = function wpfCustomThemeV2ResponseReceive(data) {
  return {
    type: WPF_CUSTOM_THEME_V2_RESPONSE_RECEIVE,
    data: data
  };
};
export var wpfCustomThemeV2RequestFail = function wpfCustomThemeV2RequestFail() {
  return {
    type: WPF_CUSTOM_THEME_V2_REQUEST_FAIL
  };
};
export var wpfCustomThemeV2Request = function wpfCustomThemeV2Request() {
  return {
    type: WPF_CUSTOM_THEME_V2_REQUEST
  };
};
export var wpfCustomThemeV2ImageUploadReceive = function wpfCustomThemeV2ImageUploadReceive(data) {
  return {
    type: WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD_RECEIVE,
    data: data
  };
};
export var wpfCustomThemeV2ImageUploadFail = function wpfCustomThemeV2ImageUploadFail() {
  return {
    type: WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD_FAIL
  };
};
export var wpfCustomThemeV2ImageUploadRequest = function wpfCustomThemeV2ImageUploadRequest() {
  return {
    type: WPF_CUSTOM_THEME_V2_IMAGE_UPLOAD
  };
};
var requredFields = ['background_image_url'];
export function saveWpfCustomThemeV2(url, data) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'PUT';
  return function (dispatch) {
    dispatch(wpfCustomThemeV2Request());
    requredFields.forEach(function (requiredField) {
      if (!data[requiredField]) {
        data[requiredField] = '';
      }
    });
    return fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        authenticity_token: window.CSRF,
        wpf_custom_theme_v2: data
      })
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(wpfCustomThemeV2ResponseReceive(json));
    })["catch"](function () {
      return dispatch(wpfCustomThemeV2RequestFail());
    });
  };
}
export function saveBackgroundImage(url, image) {
  return function (dispatch) {
    dispatch(wpfCustomThemeV2ImageUploadRequest);
    var method = 'PUT';
    return fetch(url, {
      method: method,
      body: image
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(wpfCustomThemeV2ImageUploadReceive(json));
    })["catch"](function () {
      return dispatch(wpfCustomThemeV2ImageUploadFail);
    });
  };
}